module.exports = __webpack_public_path__ + "img/nav-right-with-contact-ford.abe206b3.png";